import actionTypes from '../constants/action-types';

const setUserPartnerData = (partnerData) => ({
  type: actionTypes.SET_USER_PARTNER_DATA,
  payload: { partnerData },
});

export default setUserPartnerData;
